var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M0 .003h23.968V11H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-Selected",
    "data-testid": "user-account-link"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.995 7c0 3.86-3.14 7-7 7-3.859 0-7-3.14-7-7s3.141-7 7-7c3.86 0 7 3.14 7 7",
    id: "Fill-1",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.969.427c-.17-.117-.32-.237-.501-.35a.497.497 0 00-.513-.004 9.213 9.213 0 01-6.96 3.177A9.216 9.216 0 015.03.07a.496.496 0 00-.501.005c-.185.115-.335.237-.505.355-5.91 4.098-3.57 9.943-3.557 9.963l.11.287a.5.5 0 00.467.32h21.899a.501.501 0 00.462-.309l.126-.308c.094-.249 2.15-5.983-3.563-9.956",
    id: "Fill-3",
    fill: "#000"
  })))))));
}
SvgAccountSelected.displayName = 'AccountSelected';
export default SvgAccountSelected;